import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  standalone: true,
  selector: 'app-landing',
  imports: [],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent {
  private activatedRoute = inject(ActivatedRoute);

  loading = signal(false);

  constructor(private oauthService: OAuthService) {}

  ngOnInit(): void {
    // retornou do SOE
    if (
      this.activatedRoute.snapshot.queryParamMap.keys.filter((c) => c == 'code')
        .length > 0
    ) {
      this.loading.set(true);
    } else {
      this.loading.set(false);
    }
  }

  navigateToLoginCidadao(): void {
    this.oauthService.initCodeFlow();
  }
}
